import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

class VoucherIcon extends React.PureComponent {
  render() {
    return (
      <SvgIcon {...this.props}>
      <path
        d="M 2.53,19.655 3.875,20.21 V 11.185 L 1.45,17.04 c -0.42,1.015 0.065,2.19 1.08,2.615 z M 22.03,15.945 17.07,3.98 C 16.76,3.23 16.03,2.765 15.265,2.75 15,2.745 14.73,2.795 14.465,2.9 L 7.1,5.95 C 6.35,6.26 5.89,6.985 5.87,7.75 5.865,8.02 5.91,8.29 6.02,8.555 l 4.955,11.965 c 0.315,0.76 1.05,1.22 1.83,1.23 0.26,0 0.52,-0.045 0.775,-0.15 l 7.365,-3.05 C 21.96,18.13 22.45,16.96 22.03,15.945 Z M 7.875,8.75 c -0.55,0 -1,-0.45 -1,-1 0,-0.55 0.45,-1 1,-1 0.55,0 1,0.45 1,1 0,0.55 -0.45,1 -1,1 z m -2,11 c 0,1.1 0.9,2 2,2 H 9.33 L 5.875,13.41 Z"
        id="path2"
        style={{strokeWidth: 0.5}} />
      <path
        d="M 0,0 H 24 V 24 H 0 Z"
        id="path4"
        style={{fill:'none', strokeWidth: 0.5}} />
      </SvgIcon>
    )
  }
}

export default VoucherIcon



// WEBPACK FOOTER //
// ./src/js/components/Mui/VoucherIcon.js